
// @ts-nocheck


export const localeCodes =  [
  "en",
  "us",
  "nl",
  "fr",
  "de",
  "it",
  "id",
  "es",
  "pt",
  "br",
  "ja",
  "zh",
  "tr",
  "ko"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_GB_46json_5b87093a",
      load: () => import("#nuxt-i18n/5b87093a" /* webpackChunkName: "locale_en_GB_46json_5b87093a" */),
      cache: true
    }
  ],
  us: [
    {
      key: "locale_en_US_46json_7775058e",
      load: () => import("#nuxt-i18n/7775058e" /* webpackChunkName: "locale_en_US_46json_7775058e" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_NL_46json_0129c036",
      load: () => import("#nuxt-i18n/0129c036" /* webpackChunkName: "locale_nl_NL_46json_0129c036" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_FR_46json_8116594d",
      load: () => import("#nuxt-i18n/8116594d" /* webpackChunkName: "locale_fr_FR_46json_8116594d" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_DE_46json_309120e8",
      load: () => import("#nuxt-i18n/309120e8" /* webpackChunkName: "locale_de_DE_46json_309120e8" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_IT_46json_f044ecf9",
      load: () => import("#nuxt-i18n/f044ecf9" /* webpackChunkName: "locale_it_IT_46json_f044ecf9" */),
      cache: true
    }
  ],
  id: [
    {
      key: "locale_id_ID_46json_9c19ecf2",
      load: () => import("#nuxt-i18n/9c19ecf2" /* webpackChunkName: "locale_id_ID_46json_9c19ecf2" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_ES_46json_cf28c561",
      load: () => import("#nuxt-i18n/cf28c561" /* webpackChunkName: "locale_es_ES_46json_cf28c561" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_PT_46json_87d51bfd",
      load: () => import("#nuxt-i18n/87d51bfd" /* webpackChunkName: "locale_pt_PT_46json_87d51bfd" */),
      cache: true
    }
  ],
  br: [
    {
      key: "locale_pt_BR_46json_f2a247f8",
      load: () => import("#nuxt-i18n/f2a247f8" /* webpackChunkName: "locale_pt_BR_46json_f2a247f8" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_JP_46json_7b2ab865",
      load: () => import("#nuxt-i18n/7b2ab865" /* webpackChunkName: "locale_ja_JP_46json_7b2ab865" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_CN_46json_6bb8f7c0",
      load: () => import("#nuxt-i18n/6bb8f7c0" /* webpackChunkName: "locale_zh_CN_46json_6bb8f7c0" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_TR_46json_50351707",
      load: () => import("#nuxt-i18n/50351707" /* webpackChunkName: "locale_tr_TR_46json_50351707" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_KR_46json_c3ddf4c3",
      load: () => import("#nuxt-i18n/c3ddf4c3" /* webpackChunkName: "locale_ko_KR_46json_c3ddf4c3" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/6b2f2c53" /* webpackChunkName: "config_vueI18nConfig_46ts_6b2f2c53" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: "all",
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-GB",
      abbreviation: "en",
      name: "English",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/en_GB.json",
          cache: undefined
        }
      ]
    },
    {
      code: "us",
      language: "en-US",
      abbreviation: "en",
      name: "English (US)",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/en_US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      language: "nl-NL",
      abbreviation: "nl",
      name: "Nederlands",
      _hreflang: "nl-NL",
      _sitemap: "nl-NL",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/nl_NL.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      abbreviation: "fr",
      name: "Français",
      _hreflang: "fr-FR",
      _sitemap: "fr-FR",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/fr_FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      abbreviation: "de",
      name: "Deutsch",
      _hreflang: "de-DE",
      _sitemap: "de-DE",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/de_DE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      language: "it-IT",
      abbreviation: "it",
      name: "Italiano",
      _hreflang: "it-IT",
      _sitemap: "it-IT",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/it_IT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "id",
      language: "id-ID",
      abbreviation: "id",
      name: "Bahasa Indonesia",
      _hreflang: "id-ID",
      _sitemap: "id-ID",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/id_ID.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      abbreviation: "es",
      name: "Español",
      _hreflang: "es-ES",
      _sitemap: "es-ES",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/es_ES.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      language: "pt-PT",
      abbreviation: "pt",
      name: "Português",
      _hreflang: "pt-PT",
      _sitemap: "pt-PT",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/pt_PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "br",
      language: "pt-BR",
      abbreviation: "pt",
      name: "Português do Brasil",
      _hreflang: "pt-BR",
      _sitemap: "pt-BR",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/pt_BR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      language: "ja-JP",
      abbreviation: "ja",
      name: "日本語",
      _hreflang: "ja-JP",
      _sitemap: "ja-JP",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/ja_JP.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      language: "zh-CN",
      abbreviation: "zh",
      name: "简体中文",
      _hreflang: "zh-CN",
      _sitemap: "zh-CN",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/zh_CN.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      language: "tr-TR",
      abbreviation: "tr",
      name: "Türkçe",
      _hreflang: "tr-TR",
      _sitemap: "tr-TR",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/tr_TR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      language: "ko-KR",
      abbreviation: "ko",
      name: "한국어",
      _hreflang: "ko-KR",
      _sitemap: "ko-KR",
      files: [
        {
          path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/ko_KR.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: true,
  langDir: "crowdin/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-GB",
    abbreviation: "en",
    name: "English",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/en_GB.json",
        cache: undefined
      }
    ]
  },
  {
    code: "us",
    language: "en-US",
    abbreviation: "en",
    name: "English (US)",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/en_US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    language: "nl-NL",
    abbreviation: "nl",
    name: "Nederlands",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/nl_NL.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    abbreviation: "fr",
    name: "Français",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/fr_FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    abbreviation: "de",
    name: "Deutsch",
    _hreflang: "de-DE",
    _sitemap: "de-DE",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/de_DE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    language: "it-IT",
    abbreviation: "it",
    name: "Italiano",
    _hreflang: "it-IT",
    _sitemap: "it-IT",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/it_IT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    language: "id-ID",
    abbreviation: "id",
    name: "Bahasa Indonesia",
    _hreflang: "id-ID",
    _sitemap: "id-ID",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/id_ID.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    abbreviation: "es",
    name: "Español",
    _hreflang: "es-ES",
    _sitemap: "es-ES",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/es_ES.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt-PT",
    abbreviation: "pt",
    name: "Português",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/pt_PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "br",
    language: "pt-BR",
    abbreviation: "pt",
    name: "Português do Brasil",
    _hreflang: "pt-BR",
    _sitemap: "pt-BR",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/pt_BR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    language: "ja-JP",
    abbreviation: "ja",
    name: "日本語",
    _hreflang: "ja-JP",
    _sitemap: "ja-JP",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/ja_JP.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    language: "zh-CN",
    abbreviation: "zh",
    name: "简体中文",
    _hreflang: "zh-CN",
    _sitemap: "zh-CN",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/zh_CN.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    language: "tr-TR",
    abbreviation: "tr",
    name: "Türkçe",
    _hreflang: "tr-TR",
    _sitemap: "tr-TR",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/tr_TR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    language: "ko-KR",
    abbreviation: "ko",
    name: "한국어",
    _hreflang: "ko-KR",
    _sitemap: "ko-KR",
    files: [
      {
        path: "/home/runner/_work/monorepo/monorepo/frontend/marketplace/i18n/crowdin/ko_KR.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/